import { MapPin, Phone } from "lucide-react";
import { useCity } from "@/context/LocationContext";

const PHONE = "06 49 50 18 43";

/**
 * Bandeau noir défilant.
 * - `label` : texte personnalisé (sinon "Serrurier [Ville]" via géolocalisation)
 * - `speedSeconds` : durée d'un cycle d'animation (par défaut 30s — plus c'est petit, plus c'est rapide)
 */
const CityMarquee = ({ label, speedSeconds = 30 }) => {
    const { city, postal } = useCity();
    const fallbackLabel = city || "Dépannage Express";
    const displayLabel = label || `Serrurier ${fallbackLabel}`;
    const items = Array.from({ length: 12 });

    return (
        <section
            data-testid="city-marquee"
            aria-label={`${displayLabel} — appeler le ${PHONE}`}
            className="sticky top-16 lg:top-20 z-30 bg-[#0A0A0A] text-white border-y border-black overflow-hidden"
        >
            <a
                href="tel:+33649501843"
                data-testid="city-marquee-call"
                className="block hover:bg-[#151515] transition-colors"
                aria-label={`Appeler le serrurier au ${PHONE}`}
            >
                <div className="relative flex items-center">
                    <div className="relative z-10 hidden sm:flex items-center gap-2 bg-[#E63946] px-4 py-2.5 flex-shrink-0">
                        <MapPin className="h-3.5 w-3.5" strokeWidth={2.6} />
                        <span className="text-[10px] uppercase tracking-[0.22em] font-semibold whitespace-nowrap">
                            Intervention immédiate
                        </span>
                    </div>

                    <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[#0A0A0A] to-transparent z-[5] hidden sm:block" />

                    <div className="marquee-track flex-1 overflow-hidden">
                        <div
                            className="marquee-content flex items-center gap-8 py-2.5 whitespace-nowrap"
                            style={{ animationDuration: `${speedSeconds}s` }}
                        >
                            {items.map((_, i) => (
                                <span key={i} className="flex items-center gap-3 text-xs sm:text-sm">
                                    <span className="font-display font-bold uppercase tracking-tight">
                                        {displayLabel}
                                    </span>
                                    {!label && postal && (
                                        <span className="text-zinc-400 font-semibold">{postal}</span>
                                    )}
                                    <span className="inline-flex items-center gap-1 text-[#E63946]">
                                        <Phone className="h-3 w-3" strokeWidth={2.6} />
                                        <span className="font-display font-bold tracking-tight">{PHONE}</span>
                                    </span>
                                    <span className="text-[#E63946] ml-2" aria-hidden="true">◉</span>
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#0A0A0A] to-transparent z-[5]" />
                </div>
            </a>
        </section>
    );
};

export default CityMarquee;
